import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyAlertComponent } from './alert.component';
import { SkyResourcesModule } from '../resources';


export class SkyAlertModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [SkyAlertComponent],
  imports: [CommonModule, SkyResourcesModule],
  exports: [SkyAlertComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
